module.exports = __webpack_public_path__ + "media/images/flags/nc-2ebfe2590a9e440fba0af3c13143a9b4.svg";